import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
const Loader = () => {
  return (
    <>
      <Backdrop
  sx={{ color: '#fff', zIndex: (theme:any) => theme.zIndex.drawer + 1 }}
  open={true}
 
>
<CircularProgress color="inherit" />
</Backdrop>
    </>
  )
}

export default Loader